<template>
  <v-content class="pa-12">
    <!-- Nevigater -->
    <v-layout mb-6>
      <v-flex shrink d-flex justify-start align-center style="color: #3e7662; font-weight: bold; font-size: 24px">
        <span>ตรวจสอบแบบฟอร์ม RF</span>
      </v-flex>
    </v-layout>

    <v-layout mt-6>
      <v-flex xs1 style="font-weight: bold">
        <span>กรองประเภท</span>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex style="color: #3e7662">
        <v-radio-group hide-details v-model="filterType">
          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF12 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countRF12 > 0">{{ countRF12
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('1')" :class="checkRadio1 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการแก้ไขเพิ่มเติมโครงร่างการวิจัย (RF 12_2563)" value="1" />
                  <!--                             label="รายงานแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment Protocol)"-->
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF03 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countRF03 > 0">{{ countRF03
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('4')" :class="checkRadio4 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานความก้าวหน้าของการวิจัย/ขอต่ออายุโครงการ (RF 03_2563)" value="4" />
                  <!--                             label="รายงานความก้าวหน้าและขอต่ออายุโครงการวิจัย (Progress Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_2 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countRF04_2 > 0">{{ countRF04_2
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('8')" :class="checkRadio8 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึงประสงค์จากยา/เหตุการณ์ไม่คาดคิดจากยา (RF 04_1_2563)"
                    value="8" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์จากยา (Adverse Drug Reaction Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF06 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold" v-if="countRF06 > 0">{{ countRF06 }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('5')" :class="checkRadio5 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานแจ้งปิด/สรุปผลการวิจัย (RF 06_2563)" value="5" />
                  <!--                             label="รายงานสรุปผลการวิจัย (Final Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF04_1 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countRF04_1 > 0">{{ countRF04_1
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('2')" :class="checkRadio2 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึงประสงค์ (SAE) (RF 04_2_2563)" value="2" />
                  <!--                             label="รายงานเหตุการณ์การไม่พึ่งประสงค์ (SAE Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF07 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countRF07 > 0">{{ countRF07
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('7')" :class="checkRadio7 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการยุติโครงการวิจัยก่อนกําหนด (RF 07_2563)" value="7" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countRF05 > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countRF05 > 0">{{ countRF05
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('3')" :class="checkRadio3 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานการไม่ปฏิบัติตามข้อกำหนด (RF 05_2563)" value="3" />
                  <!--                             label="รายงานการเบี่ยงเบนโครงร่างวิจัย (Deviation Report)"-->
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countCorres > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countCorres > 0">{{ countCorres
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('6')" :class="checkRadio6 ? 'radio-checked' : ''"
                    color="#3E7662" label="เอกสารและจดหมายแจ้งเกี่ยวกับงานวิจัย (Correspondence Report)" value="6" />
                  <!--                             label="แจ้งปิดโครงการวิจัยก่อนกำหนด (Terminate)"-->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout class="my-1">
            <v-flex class="xs6 py-1"></v-flex>
            <v-flex class="xs6 py-1">
              <v-layout>
                <v-flex class="xs1 align-center d-flex justify-end">
                  <v-icon v-if="countSusar > 0" small color="#CC3D45">mdi-alert-circle</v-icon>
                  <span style="color: #cc3d45; font-weight: bold; font-size: 14px" v-if="countSusar > 0">{{ countSusar
                  }}</span>
                </v-flex>
                <v-flex xs11>
                  <v-radio class="ml-3" @click.native="checkRadio('9')" :class="checkRadio9 ? 'radio-checked' : ''"
                    color="#3E7662" label="แบบรายงานเหตุการณ์ไม่พึ่งประสงค์นอกสถาบัน SUSAR / DMC / DSMB" value="9" />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
    </v-layout>

    <v-layout my-6>
      <v-flex xs3>
        <v-text-field placeholder="รหัสโครงการวิจัย" color="#3e7662" dense outlined v-model="searchData.researchCode"
          hide-details />
      </v-flex>
      <v-flex xs3 mx-6>
        <v-text-field placeholder="ชื่อ นามสกุล ผู้วิจัย" color="#3e7662" dense outlined
          v-model="searchData.researcherName" hide-details />
      </v-flex>
      <v-flex shrink>
        <v-btn color="#3e7662" dark @click="getRF(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Table -->
    <v-layout mt-4>
      <v-flex>
        <v-card flat>
          <!-- <form-table v-if="checkRadio9" :headers="headers2" :items="listRF" onViewData></form-table> -->
          <form-table :headers="headers" :items="listRF" onViewData :send="send" :editCheckRF="editCheckRF"
            :viewCorresFile="viewCorresFile" :deleteRF="deleteRF"></form-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination color="#3E7662" :length="paginate.last_page" :total-visible="9" @input="getRF"
          v-model="paginate.current_page"></v-pagination>
      </v-flex>
    </v-layout>

    <!-- Modal View To Reviewer Files -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="viewFileDialog" persistent width="800px" max-width="80%">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4 justify-center" style="background-color: #3e7662; color: white">
              <span class="font-weight-medium font-weight-bold">ดูเอกสารแนบ</span>
            </v-card-title>
            <v-card-text class="justify-center" v-if="corresFile">
              <v-layout>
                <h2 style="margin: auto">เอกสาร Correspondence</h2>
              </v-layout>
              <v-layout my-6>
                <v-flex>
                  <a :href="corresFile.file" style="color: #3e7662" target="_blank">
                    <p style="font-size: 16px; text-align: center" class="my-2">
                      {{ corresFile.title ? corresFile.title : "ไม่มีชื่อ" }}
                    </p>
                  </a>
                </v-flex>
              </v-layout>
              <div v-if="corresOtherFile.length > 1" class="my-6">
                <v-layout>
                  <h2 style="margin: auto" class="mb-6">เอกสาร อื่นๆ</h2>
                </v-layout>
                <v-layout v-for="(file, k) in corresOtherFile" :key="k">
                  <v-flex ml-2 justify-center>
                    <a :href="file.filePath" style="color: #3e7662" target="_blank">
                      <p style="font-size: 16px; text-align: center" class="my-2">
                        {{ file.title ? file.title : "ไม่มีชื่อ" }}
                      </p>
                    </a>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-layout>
                  <v-flex my-12>
                    <p style="
                        font-size: 18px;
                        font-weight: bold;
                        color: #3e7662;
                        text-align: center;
                      ">
                      ไม่พบเอกสารแนบ
                    </p>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="viewFileDialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- Modal Edit Consider Result -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="checkRFDialog" persistent width="800px" max-width="80%">
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4">
              <span class="font-weight-medium font-weight-bold">ส่งเข้าพิจารณา</span>
            </v-card-title>
            <v-card-text>
              <!-- row 1 -->
              <v-layout mt-6 px-6>
                <v-flex xs3 mr-3 justify-end align-center d-flex>
                  <span style="font-weight: bold">เลือกอนุกรรมการ </span>
                </v-flex>
                <v-flex xs9 pt-4 class="field-select">
                  <text-autocomplete id="reviewer" placeholder="เลือก อนุกรรมการ" :items="reviewerList"
                    item-text="user_name" itemValue="user_id" :model="checkRFForm.reviewer"
                    @update-data="updateData('reviewer', $event, k)" />
                </v-flex>
              </v-layout>

              <v-divider class="mb-6"></v-divider>

              <v-layout class="py-2 font-weight-bold" style="background-color: #3e7662; color: white; font-size: 18px">
                <v-flex>
                  <span>แนบเอกสาร</span>
                </v-flex>
              </v-layout>
              <v-card class="px-6 pb-6">
                <v-layout>
                  <v-flex xs5></v-flex>
                  <v-flex xs6 mt-6 style="text-align: right">
                    <v-btn min-width="5px" small dark style="background-color: #3e7662; padding: 5px" @click="add">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 ml-2></v-flex>
                </v-layout>

                <v-layout v-for="(item, i) in checkRFForm.attachFiles" :key="i" mb-6 mt-6 class="justify-center">
                  <v-flex xs5>
                    <v-layout>
                      <v-flex shrink mr-3 class="pt-2">
                        <span class="font-weight-bold">ชื่อเอกสาร</span>
                      </v-flex>
                      <v-flex>
                        <v-text-field prepend-icon="" v-model="item.name" outlined dense background-color="#FBF6F3"
                          color="#3E7662" item-color="#3E7662"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 pl-4>
                    <v-layout class="justify-center">
                      <v-flex shrink class="pt-3 font-weight-bold mr-3">ไฟล์</v-flex>
                      <v-flex>
                        <v-layout class="mb-2">
                          <v-flex xs10 class="text-start">
                            <v-file-input accept=".pdf" prepend-icon="" :id="'file' + i" :model="item.file" outlined dense
                              background-color="#FBF6F3" color="#3E7662" item-color="#3E7662"
                              @change="setDataUploadDynamicFile($event, i)" hide-details></v-file-input>
                          </v-flex>
                          <v-flex shrink pl-4 style="text-align: left" class="d-flex align-center">
                            <v-btn color="#3E7662" dark @click="uploadDynamicFile('file' + i)">
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 pt-2 ml-2>
                    <v-btn v-if="checkRFForm.attachFiles.length > 1" min-width="5px" small dark
                      style="background-color: #cc3d45; padding: 5px" @click="remove(i)">
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="checkRFDialog = false">
                Close
              </v-btn>
              <v-btn style="font-weight: bold" color="#3E7662" text @click="send2">Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
  </v-content>
</template>

<script>
import FormTable from "../../components/table/FormTable";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import { domain } from "../../services/Constants";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import TextAutocomplete from "../../components/input/TextAutocomplete";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "Meeting",
  components: {
    FormTable,
    vSelect,
    Loading,
    TextAutocomplete,
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    filterType: "1",
    checkRadio1: true,
    checkRadio2: false,
    checkRadio3: false,
    checkRadio4: false,
    checkRadio5: false,
    checkRadio6: false,
    checkRadio7: false,
    checkRadio8: false,
    checkRadio9: false,
    checkRFDialog: false,
    viewFileDialog: false,
    isLoading: false,
    isLoadingTable: false,
    fullPage: true,
    paginate: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "ชื่องานวิจัย",
        value: "nameResearch",
        align: "center",
        sortable: false,
      },
      {
        text: "ชื่อนักวิจัย",
        value: "researcherName",
        align: "center",
        sortable: false,
        width: "15%",
      },
      {
        text: "version",
        value: "version",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "เรื่องที่",
        value: "groupID",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "สถานะการแก้ไข",
        value: "editStatus",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ดูแบบฟอร์ม",
        value: "viewOutline",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ส่งเข้าพิจารณา",
        value: "verify",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "รหัสโครงการ",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ลบเอกสาร",
        align: "center",
        sortable: false,
        width: "10%",
      },
    ],
    headers2: [
      {
        text: "ลำดับ",
        // value: "",
        align: "center",
        sortable: false,
        width: "5%",
      },
      {
        text: "รหัสโครงการ",
        // value: "",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "ผู้วิจัย",
        // value: "",
        align: "center",
        sortable: false,
        width: "15%",
      },
      {
        text: "วันที่ sponsor รายงาน",
        // value: "",
        align: "center",
        sortable: false,
        width: "15%",
      },
      {
        text: "วันที่รายงานถึงสำนักงานพิจารณาโครงการวิจัย พบ.",
        // value: "",
        align: "center",
        sortable: false,
        width: "15%",
      },
      {
        text: "SUSAR / REPORT",
        // value: "",
        align: "center",
        sortable: false,
      },
    ],
    listRF: [],
    countRF12: 0,
    countRF05: 0,
    countRF03: 0,
    countRF04_1: 0,
    countRF04_2: 0,
    countRF06: 0,
    countRF07: 0,
    countCorres: 0,
    countSusar: 0,
    checkRFForm: {
      attachFiles: [
        {
          file: "",
          name: "",
        },
      ],
      reviewer: null,
      id: null,
      version: null,
      researchID: null,
      filter: null,
    },
    corresOtherFile: [],
    corresFile: { file: "", title: "" },
    reviewerList: [],
    searchData: {
      researchCode: "",
      researcherName: "",
      filterType: 0,
    },
  }),
  created() {
    this.getReviewerList();
    this.getRF(1);
  },
  methods: {
    updateData(name, val) {
      this.checkRFForm[name] = val;
    },
    getRF(page) {
      // console.log(this.searchData.researchCode)
      this.listRF = [];
      this.isLoading = true;
      let data = {
        page: page,
        filter: this.filterType,
        researchCode: this.searchData.researchCode,
        researcherName: this.searchData.researcherName,
      };
      this.$store.dispatch("FormRF/getRF", data).then((res) => {
        this.countRF12 = res.ResearchAmendmentCount;
        this.countRF04_1 = res.AdverseEventCount;
        this.countRF05 = res.DeviationReportCount;
        this.countRF03 = res.ProgressReportCount;
        this.countRF06 = res.ResearchSummarizeCount;
        this.countRF07 = res.ResearchTerminationCount;
        this.countRF04_2 = res.AdverseDrugEventCount;
        this.countCorres = res.CorrespondenceCount;
        this.countSusar = res.FormSusarCount;
        let i = 1;
        res.data.data.forEach((data) => {
          this.listRF.push({
            number: i,
            id: data.id,
            researchID: data.researchID,
            researchCode: data.researchCode,
            researcherName: data.firstName + " " + data.lastName ?? data.fname + " " + data.lname,
            researcherName2: data.fname + " " + data.lname,
            researcherName3: data.researcherName,
            researcherName4: data.mainResearcher,
            version: data.version ? data.version : "-",
            nameResearch: data.researchName,
            otherFile: data.otherFile,
            corresFile: data.file,
            editStatus: data.editStatus,
            corresName: data.name,
            groupID: data.group_id + 1,
            research_pass: data.research_pass,
            linkEdit: this.filterType != 6 ? this.checkLink() : data.file,
            onView: 7,
            filterType: this.filterType,
            item: data,
            editStatus: data.editStatus
          });
          i++;
        });
        this.paginate.current_page = res.data.current_page;
        this.paginate.from = res.data.from;
        this.paginate.last_page = res.data.last_page;
        this.paginate.per_page = res.data.per_page;
        this.paginate.total = res.data.total;
        this.paginate.to = res.data.to;
        this.isLoading = false;
      });
    },
    checkLink() {
      if (this.filterType === "1") {
        return "ViewFormRF12";
      }
      if (this.filterType === "2") {
        return "ViewFormRF04_2";
      }
      if (this.filterType === "3") {
        return "ViewFormRF05";
      }
      if (this.filterType === "4") {
        return "ViewFormRF03";
      }
      if (this.filterType === "5") {
        return "ViewFormRF06";
      }
      if (this.filterType === "7") {
        return "ViewFormRF07";
      }
      if (this.filterType === "8") {
        return "ViewFormRF04_1";
      }
      if (this.filterType === "9") {
        return "ViewFormRFSusar";
      }
    },
    checkRadio(name) {
      if (name === "1") {
        this.checkRadio1 = true;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "2") {
        this.checkRadio1 = false;
        this.checkRadio2 = true;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "3") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = true;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "4") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = true;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "5") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = true;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "6") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = true;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "7") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = true;
        this.checkRadio8 = false;
        this.checkRadio9 = false;
      }
      if (name === "8") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = true;
        this.checkRadio9 = false;
      }
      if (name === "9") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.checkRadio5 = false;
        this.checkRadio6 = false;
        this.checkRadio7 = false;
        this.checkRadio8 = false;
        this.checkRadio9 = true;
      }
      this.getRF(1);
    },
    getReviewerList() {
      this.isLoading = true;
      this.$store
        .dispatch("User/getReviewerList")
        .then((res) => {
          this.isLoading = false;
          res.forEach((data) => {
            this.reviewerList.push({
              user_id: data.id,
              user_name: data.thName,
            });
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    editCheckRF(item) {
      this.checkRFDialog = true;
      this.checkRFForm.id = item.id;
      this.checkRFForm.version = item.version;
      this.checkRFForm.researchID = item.researchID;
      this.checkRFForm.filter = this.filterType;
    },
    viewCorresFile(item) {
      console.log("item", item);
      this.viewFileDialog = true;
      this.corresOtherFile = item.otherFile;
      this.corresFile.file = item.corresFile;
      this.corresFile.title = item.corresName;
      console.log("corresotherFile", this.corresOtherFile);
      console.log("corresfIle", this.corresFile);
    },
    deleteRF(item) {
      console.log(item);
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          let data = {
            id: item.id,
            filter: item.filterType
          }
          this.isLoading = true;
          this.$store.dispatch("FormRF/deleteRF", data).then((res) => {
            Swal.fire({
              title: "ลบเรียบร้อยแล้ว",
              icon: "success",
              position: "center",
              showConfirmButton: false,
              timer: 1500,
            })
            this.isLoading = false;
          }).catch((e) => {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              icon: "error",
              position: "center",
              showConfirmButton: false,
              timer: 1500,
            })
            location.reload();
            this.isLoading = false;
          })
        }
      })
    },
    send(val) {
      Swal.fire({
        title: "คุณต้องการส่งเข้าพิจารณาหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          let data = {
            id: val.id,
            version: val.version,
            researchID: val.researchID,
            filter: this.filterType,
          };
          this.isLoading = true;
          this.$store
            .dispatch("FormRF/checkRF", data)
            .then((res) => {
              Swal.fire({
                title: "บันทึกเรียบร้อยแล้ว",
                icon: "success",
                position: "center",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.getRF(1);
                this.isLoading = false;
              });
            })
            .catch((e) => {
              this.isLoading = false;
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "บันทึกไม่สำเร็จ",
                icon: "warning",
              });
            });
        }
      });
    },
    send2() {
      Swal.fire({
        title: "คุณต้องการส่งเข้าพิจารณาหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("FormRF/checkRF", this.checkRFForm)
            .then((res) => {
              Swal.fire({
                title: "บันทึกเรียบร้อยแล้ว",
                icon: "success",
                position: "center",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.getRF(1);
                this.checkRFDialog = false;
                this.isLoading = false;
              });
            }).catch((e) => {
              this.isLoading = false;
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "บันทึกไม่สำเร็จ",
                icon: "warning",
              });
            });
        }
      });
    },
    uploadDynamicFile(val) {
      document.getElementById(val).click();
    },
    setDataUploadDynamicFile(val, index) {
      var formData = new FormData();
      formData.append("toReviewerFile", val);
      axios
        .post(domain + "/api/upload-file-pre", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.checkRFForm.attachFiles[index].file = response.data.fileName;
          console.log("checkRFForm", this.checkRFForm);
        })
        .catch(function (error) { });
    },
    add() {
      this.checkRFForm.attachFiles.push({ name: "", file: "" });
    },
    remove(index) {
      this.checkRFForm.attachFiles.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__selected

/*.style-chooser .vs__dropdown-menu:hover*/
  {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
</style>
